<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 p-0">
          <div class="login-card">
            <div>
              <div>
                <a class="logo">
                  <img class="img-fluid for-light" src="../assets/images/logo/logo-login-430.png" alt="looginpage" />
                  <img class="img-fluid for-dark" src="../assets/images/logo/logo-login-430.png" alt="looginpage" />
                </a>
              </div>
              <div class="login-main">
                <form class="theme-form">
                  <h4>SIMM v.2.0 </h4>
                  <p>Bienvenido, ingresa tus credenciales</p>
                  <div class="form-group">
                    <label class="col-form-label">Usuario</label>
                    <input class="form-control" :class="{ 'is-invalid': user.usuario.error }"
                      type="text" required="" placeholder="usuario"
                      v-model="user.usuario.value" />
                    <div v-if="user.usuario.error" class="invalid-feedback">
                      {{ user.usuario.errorMessage }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">Contraseña</label>
                    <div class="form-input position-relative">
                      <input class="form-control" :class="{ 'is-invalid': user.password.error }"
                        :type="showPassword ? 'text' : 'password'" name="login[password]" required=""
                        placeholder="*********" v-model="user.password.value" />
                      <div v-if="user.password.error" class="invalid-feedback">
                        {{ user.password.errorMessage }}
                      </div>
                      <div class="show-hide" @click="togglePassword">
                        <span><i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i></span>
                      </div>
                    </div>
                  </div>  

                  <div class="form-group mb-0">
                    <!-- Olvido de contraseña -->
                    <!--
                    <div class="checkbox p-0">
                      <input id="checkbox1" type="checkbox" />
                      <label class="text-muted" for="checkbox1">Recordar contraseña</label>
                    </div>
                    <div class="text-end mt-3">
                      <router-link class="link" to="#">
                        ¿Olvidaste tu contraseña?
                      </router-link>
                    </div>
                    -->
                    <div class="text-end mt-3">
                      <button class="btn btn-primary btn-block w-100" type="submit" @click.prevent="login">
                        Ingresar
                      </button>
                      <div v-if="user.formError" class="text-danger mt-2">
                        {{ user.formErrorMessage }}
                      </div>
                    </div>
                  </div>  

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Efecto de processing -->
    <div class="loader-wrapper" v-if="loading">
      <div class="loader-index"><span></span></div>
      <svg>
      <defs></defs>
      <filter id="goo">
        <fegaussianblur in="SourceGraphic" stddeviation="11" result="blur"></fegaussianblur>
        <fecolormatrix in="blur" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="goo"> </fecolormatrix>
      </filter>
      </svg>
    </div> 

  </div>
</template>

<script>  
  import config from "@/axios"; 
  import { useGeneralStore } from "@/stores/generalStore";

  export default {
    setup() {
      const store = useGeneralStore(); 
      return { store };
    },
    data() {
      return {
        user: {
          usuario: {
            value: '',
            error: false,
            errorMessage: ''
          },
          password: {
            value: '',
            error: false,
            errorMessage: ''
          }
        },
        loading: false,
        showPassword: false
      }
    },
    
    mounted() {
      this.checkSession();
    },

    methods: {

      togglePassword() {
        this.showPassword = !this.showPassword;
      },

      clearUserError(field) {
        setTimeout(() => {
          this.user[field].error = false;
          this.user[field].errorMessage = '';
        }, 3000);
      },

      clearFormError() {
        setTimeout(() => {
          this.user.formError = false;
          this.user.formErrorMessage = '';
        }, 3000);
      },

      validateForm() {
        let isValid = true;

        // Validar usuario
        if (!this.user.usuario.value.trim()) {
          this.user.usuario.error = true;
          this.user.usuario.errorMessage = 'El usuario es requerido';
          this.clearUserError('usuario');
          isValid = false;
        } else {
          this.user.usuario.error = false;
          this.user.usuario.errorMessage = '';
        }

        // Validar password
        if (!this.user.password.value) {
          this.user.password.error = true;
          this.user.password.errorMessage = 'La contraseña es requerida';
          this.clearUserError('password');
          isValid = false;
        } else if (this.user.password.value.length < 6) {
          this.user.password.error = true;
          this.user.password.errorMessage = 'La contraseña debe tener al menos 6 caracteres';
          this.clearUserError('password');
          isValid = false;
        } else {
          this.user.password.error = false;
          this.user.password.errorMessage = '';
        }

        return isValid;
      },

      async checkSession() {
        this.loading = true;
        try {
          const response = await config.get('validate', {
            withCredentials: true
          });
          if (response.data && response.data.authenticated) {
            // Si hay sesión activa, cargar datos del usuario y redirigir
            this.store.setUserData({
              id: response.data.id,
              upn: response.data.upn,
              role: response.data.role,
            });
            this.$router.push('/dashboard');
          }
        } catch (error) {
          // No hay sesión activa, permanecer en login
          console.log("No hay sesión activa");          
        } finally {
          this.loading = false;
        }
      },
      
      async login() {
        if (!this.validateForm()) {
          return;
        }

        this.loading = true;
        try {
          const response = await config.get("auth", {
            params: {
              usuario: this.user.usuario.value,
              password: this.user.password.value,              
            }
          });
          
          if (response.data['message'] === 'Ok') {                                                          
            this.store.setUserData({
              id: response.data.id,
              upn: response.data.upn,
              role: response.data.role,
            });            
            // Redirige al dashboard o página principal
            this.$router.push('/dashboard');
          } else {
            this.user.formError = true;
            this.user.formErrorMessage = 'Usuario o contraseña incorrectos.';
            this.clearFormError();
          }
          
        } catch (error) {          
            this.user.formErrorMessage = 'Error de comunicación, intenta nuevamente.';
            this.user.formError = true;
            this.clearFormError();            
        } finally {
            this.loading = false;
        }
      },      
    },
  };
</script>
